<template>
  <div>
    <div class="header">
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="onDateChange"
      >
      </el-date-picker>
      <el-button type="primary" v-if="operations.includes('导出购买记录')" @click="onExportClick">导出excel</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-wrap"
    >
      <el-table-column
        prop="pay_time"
        label="购买时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="用户名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="account"
        label="用户手机号"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="member_name"
        label="购买VIP"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="amount"
        label="支付金额"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="day"
        label="有效期（天）"
        align="center"
        width="140"
      >
      </el-table-column>
    </el-table>
    <common-pagination
      :total="total"
      :page_size="page_size"
      @size-change="handelPagesizeChange"
      @page-change="handlePageChange"
    ></common-pagination>
  </div>
</template>

<script>
import { getMemberOrderRecord } from '@/api/member-setting';
import CommonPagination from '@/components/CommonPagination';
import operations from '@/mixins/operations';
import utils from '@/jslibs/utils';

export default {
  name: 'blank',
  mixins: [operations],
  data() {
    return {
      dateRange: [],
      tableData: [],
      page_size: 10,
      page_index: 1,
      total: 0
    }
  },
  components:{
    CommonPagination
  },
  mounted(){
    this._getMemberOrderRecord();
  },
  computed:{},
  methods:{
    onDateChange() {
      this.page_index = 1;
      this._getMemberOrderRecord();
    },
    handlePageChange(page) {
      this.page_index = page;
      this._getMemberOrderRecord();
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this._getMemberOrderRecord();
    },
    async _getMemberOrderRecord() {
      const dateRange = this.dateRange || [];
      const postData = {
        page_size: this.page_size,
        page_index: this.page_index,
        start_time: dateRange.length ? dateRange[0] : '',
        end_time: dateRange.length ? dateRange[1] : '',
      }
      const { status, data } = await getMemberOrderRecord(postData);
      if ( status === 200 ) {
        this.total = data.total;
        this.tableData = data.data;
        console.log(data, 'ddd')
      }
    },
    async onExportClick() {
      let loading = this.$loading({
        lock: true,
        text: '正在努力下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const res = await utils.downloadFile('/v1/cms/MemberOrderRecordExcel');
      utils.downloadBlobFile(res.data, `会员卡购买记录.xlsx`);
      loading.close();
    }
  }
}
</script>

<style lang="less" scoped>

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
</style>
